/**
 * Sets up the routing for all non-admin User views.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import user views
import OnBoarding from './views/OnBoarding.js.jsx';
import ResetPassword from './views/ResetPassword.js.jsx';
import UserLogin from './views/UserLogin.js.jsx';
import UserThirdPartyLogin from './views/UserThirdPartyLogin.js.jsx';
import UserProfile from './views/UserProfile.js.jsx';
import ChangePassword from './views/ChangePassword.js.jsx';
import RequestPasswordResetLink from './views/RequestPasswordResetLink.js.jsx'

class UserRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user/login" component={UserLogin} />
        {/* <Route exact path="/user/third-party-login/:provider" component={UserThirdPartyLogin} />
        <Route exact path="/user/forgot-password" component={RequestPasswordResetLink} />
        <Route exact path="/user/request-password-reset" component={RequestPasswordResetLink} />
        <Route exact path="/user/on-boarding/:hex" component={OnBoarding} />
        <Route exact path="/user/reset-password/:hex" component={ResetPassword} /> */}
        <YTRoute login={true} exact path="/user/profile" component={UserProfile} />
        {/* <YTRoute login={true} exact path="/user/change-password" component={ChangePassword} /> */}

      </Switch>
    )
  }
}

export default UserRouter;



// WEBPACK FOOTER //
// modules/user/UserRouter.js.jsx